export const array = [
  {
    colors: ["#ff0000", "#000000", "#CDD0D0"],
    featured: false,
    stock:12
  },
  {
    colors: ["#000000", "#22D3EF"],
    featured: false,
    stock:10
  },
  {
    colors: ["#22D3EF", "#CDD0D0"],
    featured: true,
    stock:5
  },
  {
    colors: ["#000000",  "#CDD0D0","#ff0000"],
    featured: false,
    stock:12
  },
  {
    colors: ["#C0C0C0"],
    featured: false,
    stock:8
  },
  {
    colors: ["#CDD000"],
    featured: false,
    stock:15
  },
  {
    colors: ["#CDD0D0"],
    featured: true,
    stock:6
  },
  {
    colors: ["#CDD0D0", "#B5A642"],
    featured: false,
    stock:8
  },
  {
    colors: ["#000000", "#CDD0D0"],
    featured: false,
    stock:8
  },
  {
    colors: ["#000000"],
    featured: false,
    stock:14
  },
  {
    colors: ["#ff0000", "#22D3EF", "#000000"],
    featured: false,
    stock:15
  },
  {
    colors: ["#000000", "#CDD0D0"],
    featured: true,
    stock:6
  },
  {
    colors: ["#22D3EF", "#ff0000", "#000000"],
    featured: false,
    stock:16
  },
  {
    colors: ["#000", "#4C5158", "#CDD0D0"],
    featured: false,
    stock:15
  },
  {
    colors: ["#000000", "#CDD0D0","#590168"],
    featured: true,
    stock:6
  },
  {
    colors: ["#000000", "#CDD0D0"],
    featured: false,
    stock:20
  },
  {
    colors: ["#CDD0D0", "#000000","lightblue"],
    featured: false,
    stock:12
  },
  {
    colors: ["#22D3EF", "#CDD0D0"],
    featured: false,
    stock:11
  },
  {
    colors: ["#22D3EF", "#ff0000", "#000000"],
    featured: false,
    stock:10
  },
  {
    colors: ["#000000", "#CDD0D0","purple"],
    featured: false,
    stock:9
  },
];
